<template>

    <div class="py-4 container-fluid">
      <div class="row">


        <div class="col-md-8">
          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear modelo</p>
                <argon-button  color="success" size="sm" class="ms-auto"  @click="save" :disabled="isSaving"
                  >Guardar</argon-button>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">Información</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label>
                  <argon-input type="text"  v-model="form.name"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Referencia</label>
                  <argon-input type="text"  v-model="form.ref"/>
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Referencia</label>
                  <argon-input type="text"  v-model="form.collection"/>
                </div>
                
                <div class="col-md-12">
                  <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                  <div id="processes-checkbox-list" class="checkbox-grid">
                    <div v-for="process in processes" :key="process.id" >
                      <argon-checkbox 
                        :id="'process-' + process.id" 
                        :value="process.id" 
                        :checked="form.processes.includes(process.id)"
                        v-model="form.processes" 
                      >
                        {{ process.name }}
                      </argon-checkbox>
                    </div>

                  </div>
                </div>


                <div class="col-md-6" style="display: none;">
                  <label for="example-text-input" class="form-control-label"
                    >Genero</label
                  >
                  <select ref="GenderSelect" name="" id="category_gender" class="form-select" v-model="form.category_gender">
                    <option value="" disabled>Seleccionar</option>
                    <option v-for="option in genderOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Categoria</label
                  >
                  <select ref="categorySelect" id="categorySelect" class="form-select select2" multiple style="width:100%;" v-model="form.category">
                    <option v-for="category in categories" :key="category.id" :value="category.id">
                      {{ category.fullname || category.name }}
                    </option>
                  </select>
                </div>
               
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Descripción</label
                  >
                  <argon-textarea type="text"  v-model="form.description"/>
                </div>

                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Información del diseñador</label
                  >
                  <argon-textarea type="text"  v-model="form.description_desing"/>
                </div>

                <div class="col-md-12 d-flex align-items-center mt-2">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="manageStock"
                      v-model="form.manage_stock"
                    />
                    <label class="form-check-label ms-2" for="manageStock">
                      Manejar stock del producto
                    </label>
                  </div>
                </div>

                <div class="col-md-6" v-if="form.id!=0">
                  <label for="example-text-input" class="form-control-label"
                    >Costo por unidad</label>
                  <argon-input type="text"  v-model="formattedPriceForm"/>
                </div>

                <div class="col-md-6" v-if="form.id!=0">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <select name="" id="" class="form-select" v-model="form.status">
                    <option value="1">En mejora</option>
                    <option value="0">Aprobado</option>
                    <option value="2">Rechazado</option>
                  </select>
                </div>


               

               

               
              </div>
            </div>
          </div>

          
        </div>

        

     

        <div class="col-md-4" v-if="form.id!=0">
          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Imagenes</p>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label">Seleccionar imagen</label>
                  <input
                    class="form-control"
                    type="file"
                    id="fileImagen"
                   @change="saveImagenes"
                  />
                </div>
              </div>

              <div v-if="imagenes.length > 0" class="list-group">
                <div
                  v-for="(imagen, index) in imagenes"
                  :key="imagen.id"
                  class="list-group-item d-flex justify-content-between align-items-center mt-1"
                >
                  <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;text-align: center;">
                    <div v-if="index === 0" class="text-center">
                      <img :src="this.apiUrl + imagen.file_path" alt="Imagen principal" class="img-fluid mb-2 w-50">
                    </div>
                    {{ imagen.file_name }}
                  </span>

                  <div style="align-items: center;display: flex;">
                    <a color="info"  v-if="index > 0" size="sm" @click="viewImage(imagen.file_path)">
                      <i class="fas fa-eye"></i>
                    </a>

                    <a
                    @click="deleteMedia(imagen.id)" 
                    class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 5px;"
                    data-toggle="tooltip"
                    data-original-title="Eliminar registro" 
                      >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="text-center mt-2">No hay imágenes disponibles.</p>

            </div>
          </div>

         

          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Muestras ejecutadas</p>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Seleccionar imagen</label>
                  <input class="form-control" type="file" name="" id="fileMuestras" @change="saveMuestras">
                </div>
              </div>

              <div v-if="muestras.length > 0" class="list-group">
                <div
                  v-for="imagen in muestras"
                  :key="imagen.id"
                  class="list-group-item d-flex justify-content-between align-items-center mt-1"
                >
                  <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;text-align: center;">{{ imagen.file_name }}</span>
                  <div style="align-items: center;display: flex;">
                    <a color="info" size="sm" @click="viewImage(imagen.file_path)">
                      <i class="fas fa-eye"></i>
                    </a>
                    <a
                    @click="deleteMedia(imagen.id)" 
                    class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 5px;"
                    data-toggle="tooltip"
                    data-original-title="Eliminar registro" 
                      >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="text-center mt-2">No hay imágenes disponibles.</p>
            </div>
          </div>

          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Ficha técnica</p>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Seleccionar imagen</label>
                  <input class="form-control" type="file" name="" id="fileFicha" @change="saveFicha">
                </div>
              </div>
              <div v-if="fichas.length > 0" class="list-group">
                <div
                  v-for="imagen in fichas"
                  :key="imagen.id"
                  class="list-group-item d-flex justify-content-between align-items-center mt-1"
                >
                  <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;text-align: center;">{{ imagen.file_name }}</span>
                  <div style="align-items: center;display: flex;">
                    <a color="info" size="sm" @click="viewPdf(imagen.file_path)">
                      <i class="fas fa-eye"></i>
                    </a>
                    <a
                    @click="deleteMedia(imagen.id)" 
                    class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 5px;"
                    data-toggle="tooltip"
                    data-original-title="Eliminar registro" 
                      >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="text-center mt-2">No hay imágenes disponibles.</p>
            </div>
          </div>

        </div>

        
        <div class="col-md-12" >
          <div class="card" v-if="form.id!=0">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Tallas y colores</p>
              <div class="ms-auto d-flex gap-2">
                <argon-button  color="info" size="sm" @click="toggleAllAccordions">
                  {{ todosExpanded ? 'Minimizar todos' : 'Desplegar todos' }}
                </argon-button>
                <argon-button  color="success" size="sm" @click="openModal"
                  >Agregar</argon-button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              
              <div class="accordion" id="accordionTallas" v-if="data && data.length > 0">
                <template v-for="(group, index) in data" :key="index">
                  <div class="accordion-item mb-3">
                    <h2 class="accordion-header" :id="'heading' + index">
                      <button 
                        class="accordion-button bg-primary btn-primary" 
                        :class="{ 'collapsed': index !== 0 }"
                        type="button" 
                        :data-bs-toggle="'collapse'" 
                        :data-bs-target="'#collapse' + index"
                        :aria-expanded="index === 0 ? 'true' : 'false'"
                        :aria-controls="'collapse' + index"
                      >
                        <div class="d-flex justify-content-between align-items-center w-100 me-3">
                          <p style="font-size:14px;font-weight:bold;margin:0">
                            Talla: {{ group?.size }} - Color: {{ group?.color?.name }} ({{ group?.color?.ref }})
                          </p>
                          <div style="z-index: 10; display: flex; gap: 10px;">
                            <a
                              @click.stop="openModalInsumoTalla(group)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer"
                              data-toggle="tooltip"
                              data-original-title="Agregar insumo"
                            >
                              <i class="fa fa-plus"></i>
                            </a>
                            <a
                              @click.stop="deleteModelRegister(group.id)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer"
                              data-toggle="tooltip"
                              data-original-title="Eliminar registro"
                            >
                              <i class="fa fa-trash"></i>
                            </a>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div 
                      :id="'collapse' + index" 
                      class="accordion-collapse collapse border border-primary rounded-bottom" 
                      :class="{ 'show': index === 0 }"
                      :aria-labelledby="'heading' + index"
                      data-bs-parent="#accordionTallas"
                    
                    >
                      <div class="accordion-body p-0">
                        <div class="table-responsive p-0">
                          <table class="table align-items-center mb-0 rounded-bottom">
                            <thead>
                              <tr>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant/stock</th>
                                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Opciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Detalles del grupo -->
                              <tr v-for="detail in group.details" :key="detail.id">
                                <td>
                                  <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                      <h6 class="mb-0 text-sm">{{ detail.inventory.name }}</h6>
                                    </div>
                                  </div>
                                </td>
                                <td class="align-middle text-center text-sm d-flex" style="align-items: center;justify-content: center;">

                                  <input 
                                  class="form-control w-50" 
                                  type="number" 
                                  step="0.001"
                                  v-model.number="detail.quantity" 
                                  :data-id="detail.id"
                                  @change="onQuantityChange(detail, detail.quantity)"
                                  onkeypress="return (event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 37 || event.keyCode === 39 ? true : event.preventDefault()"
                                />                            
                                <span 
                                    class="badge m-1" 
                                    :class="{
                                      'bg-danger': parseFloat(detail.inventory.quantity) < parseFloat(detail.quantity), 
                                      'bg-secondary': parseFloat(detail.inventory.quantity) >= parseFloat(detail.quantity)
                                    }">
                                    {{ detail.inventory.quantity }}
                                  </span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  {{ parseFloat(detail.price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td class="align-middle text-center text-sm">
                                  {{ parseFloat(detail.total_price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td class="align-middle text-center">
                                  <a
                                    @click="editModal(detail)" 
                                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                                    data-toggle="tooltip"
                                    data-original-title="Editar registro" 
                                  >
                                    <i class="fa fa-pencil-alt"></i>
                                  </a>

                                  <a
                                    @click="deleteRegister(detail.id)" 
                                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                                    style="margin-left: 15px;"
                                    data-toggle="tooltip"
                                    data-original-title="Eliminar registro" 
                                  >
                                    <i class="fa fa-trash"></i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="3" class="text-end text-sm font-weight-bold">Total General:</td>
                                <td class="text-center text-sm font-weight-bold">
                                  {{ (group?.total_for_size || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td colspan="2"></td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div v-else class="text-center text-secondary text-sm p-4">
                No hay registros disponibles
              </div>

              <table class="table text-bold">
                <tbody>
                  <tr>
                    <td>Promedio de costos por unidad</td>
                    <td style="text-align:right">{{ averageCost }}</td>
                  </tr>
                  
                </tbody>
              </table>

            </div>
          </div>
          </div>
        </div>

       



      </div>

    <!-- Modal Asignar tecnico -->
  <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar insumo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="mb-3">
              <label for="tallaBudgetSelect" class="form-label">Talla</label>
              <select ref="tallaBudgetSelect" id="tallaBudgetSelect" class="form-select select2" multiple style="width:100%;" >
                <option v-for="size in sizesList" :key="size" :value="size">{{ size }}</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="colorBudgetSelect" class="form-label">Color</label>
              <select ref="colorBudgetSelect" id="colorBudgetSelect" class="form-select select2" multiple style="width:100%;" >
                <option v-for="color in colors" :key="color.id" :value="color.id">
                  {{ color.name }} ({{ color.ref }})
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label for="insumosBudgetSelect" class="form-label">Insumo</label>
              <select ref="insumosBudgetSelect" id="insumosBudgetSelect" class="form-select select2" multiple style="width:100%;" >
                <option v-for="process in insumos" :key="process.id" :value="process.id">
                  {{ process.name }} - ({{ process.ref }})
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="cantidadInsumoBudget" class="form-label">Cantidad</label>
              <input type="number" id="cantidadInsumoBudget" v-model.number="insumoQuantityBudget" class="form-control" min="0" step="1" placeholder="0" />
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="ModalEditInsumo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Editar insumo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="mb-3">
              <label class="form-label">Insumo</label>
              <select ref="insumosEditSelect" id="insumosEdit" class="form-select select2" style="width:100%;" >
                <option v-for="process in insumos" :key="process.id" :value="process.id">
                  {{ process.name }} - ({{ process.ref }})
                </option>
              </select>
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeEditModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitEditForm">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Agregar insumo a talla específica -->
  <div class="modal fade" id="ModalInsumoTalla" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar insumo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="tallaSelect" class="form-label">Talla</label>
              <select ref="tallaInsumoSelect" id="tallaSelect" class="form-select select2" style="width:100%;" >
                <option value="">Seleccionar talla</option>
                <option v-for="size in sizesList" :key="size" :value="size">{{ size }}</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="colorSelect" class="form-label">Color</label>
              <select ref="colorInsumoSelect" id="colorSelect" class="form-select select2" style="width:100%;" >
                <option value="">Seleccionar color</option>
                <option v-for="color in colors" :key="color.id" :value="color.id">
                  {{ color.name }} ({{ color.ref }})
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label for="insumosSelect" class="form-label">Insumo</label>
              <select ref="insumosTallaSelect" id="insumosSelect" class="form-select select2" multiple style="width:100%;" >
                <option v-for="process in insumos" :key="process.id" :value="process.id">
                  {{ process.name }} - ({{ process.ref }})
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="cantidadInsumoTalla" class="form-label">Cantidad</label>
              <input type="number" id="cantidadInsumoTalla" v-model.number="insumoQuantityTalla" class="form-control" min="0" step="1" placeholder="0" />
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModalInsumoTalla">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitFormInsumoTalla">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Agregar Talla -->
  <div class="modal fade" id="ModalTalla" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar Talla</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="example-text-input" class="form-label">Talla</label>
              <select name="" id="tallasModal" ref="tallasSelectModal"  class="form-select select2" multiple style="width:100%;">
                <option value="">Seleccionar</option>
                <option v-for="size in sizesList" :key="size" :value="size">{{ size }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="example-text-input" class="form-label">Color</label>
              <select name="" id="coloresModal" ref="colorSelectModal" class="form-select select2" multiple style="width:100%;">
                <option value="">Seleccionar</option>
                <option v-for="value in colors" :key="value.id" :value="value.id">{{ value.name }} ({{ value.ref }})</option>
              </select>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModalTalla">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="saveSize">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Dos columnas iguales */
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal, Collapse } from 'bootstrap';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_IMAGE_URL,
      showMenu: false,
      isSaving: false,
      modalBudget:null,
      modalEdit:null,
      modalInsumoTalla:null,
      modalTalla:null,
      selectedGroup: null,
      insumoQuantityBudget: 0,
      insumoQuantityTalla: 0,
      isFinish:false,
      todosExpanded: false,
      form: {
        id:0,
        name: '',
        ref: '',
        category_gender: '',
        category: '',
        collection: '',
        processes: [],
        description: '',
        description_desing: '',
        price: 0,
        manage_stock: true,
        status: 1,
      },
      genderOptions: [
        { value: 'male', label: 'Hombre' },
        { value: 'female', label: 'Mujer' },
        { value: 'boy', label: 'Niño' },
        { value: 'girl', label: 'Niña' },
      ],
      processes: [
      ],
      size:{
        size:[],
        color_id:[],
        model_id:'',
        quantity:0,
        status:1
      },
      sizesList: [
      ],
      categories:[],
      parents:[],
      imagenes:[],
      muestras:[],
      fichas:[],
      insumos: [],
      users: [],
      colors: [],
      sizes:[],
      data: [],
      modal: {
        id:0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      purchase:{
        id:0,
        model_id:0,
        inventory_id:[],
        quantity:0,
        price:0,
        total_price:0,
        size_id:[],
      },
      modalEvidencia: []
    };
  },
  components: { ArgonInput, ArgonButton,ArgonTextarea,ArgonCheckbox },
  computed: {
    averageCostValue() {
      const totalCost = this.data.reduce((sum, group) => sum + (group.total_for_size || 0), 0);
      const itemCount = this.data.length;
      return itemCount > 0 ? parseFloat((totalCost / itemCount).toFixed(2)) : 0;
    },
    averageCost() {
      return this.averageCostValue.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formattedPriceForm: {
      get() {
        return this.form.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.form.price = parseFloat(value.replace(/\./g, "") || 0);
        // Si el precio por unidad cambia, actualiza el total automáticamente
      },
    },
    formattedTotalBudget: {
      get() {
        // Formatea el total_budget a punto de mil
        return this.form.total_budget.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el total_budget
        this.form.total_budget = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedAmount: {
      get() {
        // Formatea el total_budget a punto de mil
        return this.modal.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el total_budget
        this.modal.amount = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedPrice: {
      get() {
        return this.purchase.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.purchase.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPrice() {
      // Calcula el total y aplica el formateo
      const total = Math.floor(this.purchase.quantity * this.purchase.price);
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
  },
  methods: {
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    toggleAllAccordions() {
      this.$nextTick(() => {
        const accordion = document.getElementById('accordionTallas');
        if (!accordion) return;

        const collapseElements = accordion.querySelectorAll('.accordion-collapse');
        
        if (this.todosExpanded) {
          // Colapsar todos y restaurar data-bs-parent para comportamiento normal
          collapseElements.forEach((element) => {
            const collapse = Collapse.getInstance(element) || new Collapse(element, { toggle: false });
            collapse.hide();
          });
          // Restaurar data-bs-parent después de un pequeño delay
          setTimeout(() => {
            collapseElements.forEach((element) => {
              element.setAttribute('data-bs-parent', '#accordionTallas');
            });
          }, 350);
          this.todosExpanded = false;
        } else {
          // Remover data-bs-parent para permitir múltiples acordeones abiertos
          collapseElements.forEach((element) => {
            element.removeAttribute('data-bs-parent');
          });
          // Expandir todos
          collapseElements.forEach((element) => {
            const collapse = Collapse.getInstance(element) || new Collapse(element, { toggle: false });
            collapse.show();
          });
          this.todosExpanded = true;
        }
      });
    },
    async onQuantityChange(value, newQuantity) {

      this.purchase.id = value.id;
      this.purchase.inventory_id = value.inventory_id;
      this.purchase.quantity = newQuantity;
      await this.$store.dispatch("modelsDetails/save", this.purchase);

      this.getData();

    },
    async getTallas() {
      const response = await this.$store.dispatch("tallas/getAll");
      this.sizesList = response.map(item => item.size);
    },
    async getCategories() {
      const response = await this.$store.dispatch("categories/getCategories");
      this.categories = response.data;
      // Ordenar por fullname para mostrar la jerarquía correctamente
      this.categories.sort((a, b) => {
        const fullnameA = a.fullname || a.name || '';
        const fullnameB = b.fullname || b.name || '';
        return fullnameA.localeCompare(fullnameB);
      });
      this.parents = this.categories.filter(category => category.parent_id === null);
      
      // Inicializar select2 de categoría después de cargar las categorías
      this.$nextTick(() => {
        if (this.$refs.categorySelect) {
          // Destruir select2 si ya existe
          if ($(this.$refs.categorySelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.categorySelect).select2('destroy');
          }
          
          // Inicializar select2 múltiple
          $(this.$refs.categorySelect).select2({
            placeholder: 'Seleccionar categorías',
            allowClear: true,
            width: '100%'
          });
          
          // Sincronizar con v-model cuando cambie select2
          $(this.$refs.categorySelect).on('change', () => {
            this.form.category = $(this.$refs.categorySelect).val() || [];
          });
          
          // Establecer el valor inicial si existe
          if (this.form.category && this.form.category.length > 0) {
            // Si category es un string (JSON), parsearlo
            let categoryArray = this.form.category;
            if (typeof categoryArray === 'string') {
              try {
                categoryArray = JSON.parse(categoryArray);
              } catch (e) {
                // Si no es JSON válido, intentar como array simple
                categoryArray = categoryArray.split(',').map(id => id.trim());
              }
            }
            // Asegurar que sea un array
            if (!Array.isArray(categoryArray)) {
              categoryArray = [categoryArray];
            }
            // Convertir a números si es necesario
            categoryArray = categoryArray.map(id => String(id));
            this.form.category = categoryArray;
            $(this.$refs.categorySelect).val(categoryArray).trigger('change');
          }
        }
      });
    },
    async getParents() {
      this.parents = this.categories.filter(category => category.parent_id === null);
    },
    async getImages() {
      let media =  await this.$store.dispatch('media/getData',this.form.id); 

      this.imagenes = media.data.filter(item => item.mediaable_type === 'imagenes');
      this.muestras = media.data.filter(item => item.mediaable_type === 'muestras');
      this.fichas = media.data.filter(item => item.mediaable_type === 'ficha');
    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
      
      // Inicializar Select2 después de abrir el modal
      this.$nextTick(() => {
        // Inicializar select de talla
        if (this.$refs.tallaBudgetSelect) {
          if ($(this.$refs.tallaBudgetSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.tallaBudgetSelect).select2('destroy');
          }
          $(this.$refs.tallaBudgetSelect).select2({
            placeholder: 'Seleccionar tallas',
            allowClear: true,
            dropdownParent: $('#ModalBudget .modal-body'),
            width: '100%'
          });
        }

        // Inicializar select de color
        if (this.$refs.colorBudgetSelect) {
          if ($(this.$refs.colorBudgetSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.colorBudgetSelect).select2('destroy');
          }
          $(this.$refs.colorBudgetSelect).select2({
            placeholder: 'Seleccionar colores',
            allowClear: true,
            dropdownParent: $('#ModalBudget .modal-body'),
            width: '100%'
          });
        }

        // Inicializar select de insumos
        if (this.$refs.insumosBudgetSelect) {
          if ($(this.$refs.insumosBudgetSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.insumosBudgetSelect).select2('destroy');
          }
          $(this.$refs.insumosBudgetSelect).select2({
            placeholder: 'Seleccionar insumos',
            allowClear: true,
            dropdownParent: $('#ModalBudget .modal-body'),
            width: '100%'
          });
        }
      });
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
      if (this.$refs.tallaBudgetSelect) {
        $(this.$refs.tallaBudgetSelect).val(null).trigger('change');
      }
      if (this.$refs.colorBudgetSelect) {
        $(this.$refs.colorBudgetSelect).val(null).trigger('change');
      }
      if (this.$refs.insumosBudgetSelect) {
        $(this.$refs.insumosBudgetSelect).val(null).trigger('change');
      }
      this.insumoQuantityBudget = 0;
    },
    openModalInsumoTalla(group) {
      this.selectedGroup = group;
      const modalElement = document.getElementById('ModalInsumoTalla');
      this.modalInsumoTalla = new Modal(modalElement);
      this.modalInsumoTalla.show();
      
      // Inicializar Select2 después de abrir el modal
      this.$nextTick(() => {
        // Pre-seleccionar la talla y color del grupo
        const selectedTalla = group?.size || null;
        const selectedColor = group?.color_id || group?.color?.id || null;
        
        // Inicializar select de talla
        if (this.$refs.tallaInsumoSelect) {
          if ($(this.$refs.tallaInsumoSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.tallaInsumoSelect).select2('destroy');
          }
          
          $(this.$refs.tallaInsumoSelect).select2({
            placeholder: 'Seleccionar talla',
            allowClear: true,
            dropdownParent: $('#ModalInsumoTalla .modal-body'),
            width: '100%'
          });
          
          // Pre-seleccionar la talla después de inicializar Select2
          if (selectedTalla) {
            $(this.$refs.tallaInsumoSelect).val(selectedTalla).trigger('change');
          }
        }

        // Inicializar select de color
        if (this.$refs.colorInsumoSelect) {
          if ($(this.$refs.colorInsumoSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.colorInsumoSelect).select2('destroy');
          }
          
          $(this.$refs.colorInsumoSelect).select2({
            placeholder: 'Seleccionar color',
            allowClear: true,
            dropdownParent: $('#ModalInsumoTalla .modal-body'),
            width: '100%'
          });
          
          // Pre-seleccionar el color después de inicializar Select2
          if (selectedColor) {
            $(this.$refs.colorInsumoSelect).val(selectedColor).trigger('change');
          }
        }

        // Inicializar select de insumos
        if (this.$refs.insumosTallaSelect) {
          if ($(this.$refs.insumosTallaSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.insumosTallaSelect).select2('destroy');
          }
          $(this.$refs.insumosTallaSelect).select2({
            placeholder: 'Seleccionar insumos',
            allowClear: true,
            dropdownParent: $('#ModalInsumoTalla .modal-body'),
            width: '100%'
          });
        }
      });
    },
    closeModalInsumoTalla() {
      if (this.modalInsumoTalla) {
        this.modalInsumoTalla.hide();
      }
      this.selectedGroup = null;
      if (this.$refs.tallaInsumoSelect) {
        $(this.$refs.tallaInsumoSelect).val(null).trigger('change');
      }
      if (this.$refs.colorInsumoSelect) {
        $(this.$refs.colorInsumoSelect).val(null).trigger('change');
      }
      if (this.$refs.insumosTallaSelect) {
        $(this.$refs.insumosTallaSelect).val(null).trigger('change');
      }
      this.insumoQuantityTalla = 0;
    },
    async submitFormInsumoTalla() {
      try {
        const selectedTalla = $(this.$refs.tallaInsumoSelect).val();
        const selectedColor = $(this.$refs.colorInsumoSelect).val();
        const selectedInsumos = $(this.$refs.insumosTallaSelect).val() || [];
        
        if (!selectedTalla) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar una talla.',
          });
          return;
        }

        if (!selectedColor) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar un color.',
          });
          return;
        }
        
        if (selectedInsumos.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar al menos un insumo.',
          });
          return;
        }

        Swal.fire({
          icon: 'info',
          title: 'Cargando...',
          text: 'Estamos guardando los insumos, por favor espera.',
          didOpen: () => {
            Swal.showLoading();
          },
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });

        const quantityTalla = typeof this.insumoQuantityTalla === 'number' && this.insumoQuantityTalla >= 0
          ? this.insumoQuantityTalla
          : (parseFloat(this.insumoQuantityTalla) || 0);
        const purchaseData = {
          model_id: this.form.id,
          size: [selectedTalla], // Array de tallas (strings)
          color_id: [selectedColor], // Array de colores
          inventory_id: selectedInsumos, // Array de insumos
          quantity: quantityTalla >= 0 ? quantityTalla : 0,
          price: this.form.price || 0, // Precio del modelo
        };

        const response = await this.$store.dispatch("modelsModel/save", purchaseData);
        
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'Los insumos han sido asignados correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getData();
            this.closeModalInsumoTalla();
          });
        } else {
          throw new Error(response.data?.message || 'Error al asignar los insumos');
        }

      } catch (error) {
        Swal.close();
        console.error("Error al asignar insumos:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al asignar los insumos',
        });
      }
    },
    editModal(detail) {
      this.purchase = {
        id:detail.id,
        inventory_id: detail.inventory_id,
        quantity:detail.quantity,
      };

      $('#insumosEdit').val(detail.inventory_id).trigger('change');
      const modalElement = document.getElementById('ModalEditInsumo');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    async getInsumos() {
      this.insumos = await this.$store.dispatch('inventory/getAll'); 
    },
    async getData() {
      await this.$store.dispatch('modelsModel/getData',this.form.id); 
      this.data = this.$store.state.modelsModel.getData;
      // Actualizar el precio del modelo en la base de datos con el promedio calculado
      await this.updateModelPrice();
    },
    async updateModelPrice() {
      // Solo actualizar si el modelo ya existe y hay datos
      if (this.form.id !== 0 && this.data && this.data.length > 0) {
        const promedio = this.averageCostValue;
        if (promedio > 0) {
          try {
            // Actualizar solo el precio del modelo
            const updateData = {
              ...this.form,
              price: promedio
            };
            await this.$store.dispatch("models/save", updateData);
            // Actualizar el precio localmente
            this.form.price = promedio;
          } catch (error) {
            console.error("Error al actualizar el precio del modelo:", error);
          }
        }
      }
    },
    async getOficios() {
      this.processes =  await this.$store.dispatch('users/getOficios'); 
    },
    async getColors() {
      this.colors =  await this.$store.dispatch('models/colors'); 
    },
    async getSizes() {
      this.sizes =  await this.$store.dispatch('models/sizes',this.form.id); 
    },
    openModalTalla() {
      const modalElement = document.getElementById('ModalTalla');
      this.modalTalla = new Modal(modalElement);
      this.modalTalla.show();
      
      // Inicializar Select2 después de abrir el modal
      this.$nextTick(() => {
        if (this.$refs.tallasSelectModal) {
          // Destruir select2 si ya existe
          if ($(this.$refs.tallasSelectModal).hasClass('select2-hidden-accessible')) {
            $(this.$refs.tallasSelectModal).select2('destroy');
          }

          // Inicializar select2
          $(this.$refs.tallasSelectModal).select2({
            placeholder: 'Seleccionar tallas',
            allowClear: true,
            dropdownParent: $('#ModalTalla .modal-body'),
            width: '100%'
          });

          // Actualizar el valor cuando se seleccione una opción en select2
          $(this.$refs.tallasSelectModal).on('change', () => {
            this.size.size = $(this.$refs.tallasSelectModal).val();
          });
        }

        if (this.$refs.colorSelectModal) {
          // Destruir select2 si ya existe
          if ($(this.$refs.colorSelectModal).hasClass('select2-hidden-accessible')) {
            $(this.$refs.colorSelectModal).select2('destroy');
          }

          // Inicializar select2
          $(this.$refs.colorSelectModal).select2({
            placeholder: 'Seleccionar colores',
            allowClear: true,
            dropdownParent: $('#ModalTalla .modal-body'),
            width: '100%'
          });

          // Actualizar el valor cuando se seleccione una opción en select2
          $(this.$refs.colorSelectModal).on('change', () => {
            this.size.color_id = $(this.$refs.colorSelectModal).val();
          });
        }
      });
    },
    closeModalTalla() {
      if (this.modalTalla) {
        this.modalTalla.hide();
      }
      // Limpiar selecciones
      this.size.size = [];
      this.size.color_id = [];
      if (this.$refs.tallasSelectModal) {
        $(this.$refs.tallasSelectModal).val(null).trigger('change');
      }
      if (this.$refs.colorSelectModal) {
        $(this.$refs.colorSelectModal).val(null).trigger('change');
      }
    },
    async saveSize() {

      try {

        if (!this.size.color_id || !this.size.size) {
            await Swal.fire({
                icon: 'error',
                title: '¡Error!',
                text: 'Por favor, asegúrese de seleccionar un color y una talla.',
                confirmButtonText: 'Aceptar',
            });
            return; // Detener la ejecución si falta algún campo
        }

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("models/saveSize", this.size);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'La talla ha sido guardada correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getSizes();
                this.size.size = [];
                this.size.color_id = [];
                this.size.quantity = 0;

                $(this.$refs.tallasSelectModal).val(null).trigger('change');
                $(this.$refs.colorSelectModal).val(null).trigger('change');

                this.closeModalTalla();
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar la talla');
        }

      } catch (error) {
        console.error("Error al crear la talla:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      } 
    },
    async deleteMedia(idd) {
       await this.$store.dispatch("media/delete", idd);
       this.getImages();
    },
    async deleteSize(idd) {
       const response = await this.$store.dispatch("sizes/delete", idd);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'la talla ha sido eliminada correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          });

          this.getSizes();

        }else{
          await Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Ya hay insumos relacionados con la talla, primero elimine el modelo en insumos',
          });
        }
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Preparar el formulario para enviar (convertir category a JSON si es array)
        const formData = { ...this.form };
        if (Array.isArray(formData.category)) {
          formData.category = JSON.stringify(formData.category);
        }
        
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("models/save", formData);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.form = response.data;
                this.form.id = response.data.id || 0;
                this.form.manage_stock = this.normalizeBoolean(response.data.manage_stock);
                // Parsear category si viene como JSON string
                if (response.data.category) {
                  try {
                    this.form.category = JSON.parse(response.data.category);
                  } catch (e) {
                    if (typeof response.data.category === 'string' && response.data.category.includes(',')) {
                      this.form.category = response.data.category.split(',').map(id => String(id.trim()));
                    } else {
                      this.form.category = [String(response.data.category)];
                    }
                  }
                } else {
                  this.form.category = [];
                }
                this.size.model_id = response.data.id || 0;
                this.modal.project_id = response.data.id || 0;
                this.purchase.model_id = response.data.id || 0;

                this.$nextTick(() => {
                    $(this.$refs.userSelect).select2({
                      placeholder: 'Seleccione un usuario',
                      allowClear: false,
                      dropdownParent: $('#ModalBudget .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.userSelect).on('change', () => {
                      this.modal.user_id = $(this.$refs.userSelect).val();
                    });

                    $(this.$refs.insumosSelect).select2({
                      placeholder: 'Seleccione un insumo',
                      allowClear: false,
                      dropdownParent: $('#ModalBudget .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.insumosSelect).on('change', () => {
                      this.purchase.inventory_id = $(this.$refs.insumosSelect).val();
                    });

                    $(this.$refs.insumosEditSelect).select2({
                      placeholder: 'Seleccione un insumo',
                      allowClear: false,
                      dropdownParent: $('#ModalEditInsumo .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.insumosEditSelect).on('change', () => {
                      this.purchase.inventory_id = $(this.$refs.insumosEditSelect).val();
                    });

                    

                    $(this.$refs.tallaSelect).select2({
                      placeholder: 'Seleccione un talla y color',
                      allowClear: false,
                      dropdownParent: $('#ModalBudget .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.tallaSelect).on('change', () => {
                      this.purchase.size_id = $(this.$refs.tallaSelect).val();
                    });



                  });
                  
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
    async saveImagenes() {
      try {

        const fileInput = document.getElementById("fileImagen");
        const file = fileInput.files[0];

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'imagenes');
        formData.append("file", file);

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getImages();
                fileInput.value = '';
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async saveMuestras() {
      try {

        const fileInput = document.getElementById("fileMuestras");
        const file = fileInput.files[0];

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'muestras');
        formData.append("file", file);

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                fileInput.value = '';
                this.getImages();
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async saveFicha() {
      try {

        const fileInput = document.getElementById("fileFicha");
        const file = fileInput.files[0];

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'ficha');
        formData.append("file", file);

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getImages();
                fileInput.value = '';
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitEditForm(){

      try {
        const response = await this.$store.dispatch("modelsDetails/save", this.purchase);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then(() => {
            this.getData();
            this.closeEditModal();
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    },
    async submitForm() {
      try {

        Swal.fire({
          icon: 'info',
          title: 'Cargando...',
          text: 'Estamos obteniendo los datos, por favor espera.',
          didOpen: () => {
            Swal.showLoading();
          },
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
        const selectedTallas = $(this.$refs.tallaBudgetSelect).val() || [];
        const selectedColors = $(this.$refs.colorBudgetSelect).val() || [];
        const selectedInsumos = $(this.$refs.insumosBudgetSelect).val() || [];

        if (selectedTallas.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar al menos una talla.',
          });
          return;
        }

        if (selectedColors.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar al menos un color.',
          });
          return;
        }

        if (selectedInsumos.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar al menos un insumo.',
          });
          return;
        }

        const quantity = typeof this.insumoQuantityBudget === 'number' && this.insumoQuantityBudget >= 0
          ? this.insumoQuantityBudget
          : (parseFloat(this.insumoQuantityBudget) || 0);
        const purchaseData = {
          model_id: this.form.id,
          size: selectedTallas, // Array de tallas (strings)
          color_id: selectedColors, // Array de colores
          inventory_id: selectedInsumos, // Array de insumos
          quantity: quantity >= 0 ? quantity : 0,
          price: this.form.price || 0, // Precio del modelo
        };

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("modelsModel/save", purchaseData);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
            Swal.close();
              if (result.isConfirmed) {
                this.getData();
                this.closeModal();
                

              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("modelsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteModelRegister(userId) {

      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("modelsModel/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewPdf(file_path) {
      const pdfUrl = this.apiUrl + file_path;
      window.open(pdfUrl, '_blank');
    },
    viewImage(file_path) {

      const imageHtml = `<img src="${this.apiUrl + file_path}" alt="Evidencia" style="width: 100%; height: auto;" />`;

      // Mostrar la imagen en un SweetAlert
      Swal.fire({
          html: imageHtml,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Cerrar',
          backdrop: false, 
          customClass: {
              popup: 'modal-dialog modal-dialog-centered', // Clases de Bootstrap para el modal
          },
      });
    },
  
  },
  mounted() {

    this.getTallas();

    this.getCategories();

    this.getInsumos();

    this.getOficios();

    const route = useRoute();
    const dataEdit = route.params.data;


    this.$nextTick(() => {
      $(this.$refs.userSelect).select2({
        placeholder: 'Seleccione un usuario',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.userSelect).on('change', () => {
        this.modal.user_id = $(this.$refs.userSelect).val();
      });

      $(this.$refs.insumosSelect).select2({
        placeholder: 'Seleccione un insumo',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.insumosSelect).on('change', () => {
        this.purchase.inventory_id = $(this.$refs.insumosSelect).val();
      });

      $(this.$refs.insumosEditSelect).select2({
        placeholder: 'Seleccione un insumo',
        allowClear: false,
        dropdownParent: $('#ModalEditInsumo .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.insumosEditSelect).on('change', () => {
        this.purchase.inventory_id = $(this.$refs.insumosEditSelect).val();
      });

      $(this.$refs.tallaSelect).select2({
        placeholder: 'Seleccione un talla y color',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.tallaSelect).on('change', () => {
        this.purchase.size_id = $(this.$refs.tallaSelect).val();
      });



    });

    if (dataEdit) {
        try {
            const params = JSON.parse(dataEdit); 

            if (params && params.id) {
                this.size.model_id = params.id || 0;

                this.purchase.model_id  = params.id || 0;

                this.form.id = params.id || 0;
                this.form.name = params.name || '';
                this.form.ref = params.ref || 0;

                this.form.collection = params.collection || '';
                // Parsear category si viene como JSON string
                if (params.category) {
                  try {
                    this.form.category = JSON.parse(params.category);
                  } catch (e) {
                    // Si no es JSON, intentar como array simple o número
                    if (typeof params.category === 'string' && params.category.includes(',')) {
                      this.form.category = params.category.split(',').map(id => String(id.trim()));
                    } else {
                      this.form.category = [String(params.category)];
                    }
                  }
                } else {
                  this.form.category = [];
                }

                this.form.processes = JSON.parse(params.processes) || []; 
                $(this.$refs.processesSelect).val(this.form.processes).trigger('change');
                
                // Establecer el valor en select2 de categoría después de que se carguen las categorías
                this.$nextTick(() => {
                  if (this.$refs.categorySelect && this.form.category && this.form.category.length > 0) {
                    const categoryArray = Array.isArray(this.form.category) 
                      ? this.form.category.map(id => String(id))
                      : [String(this.form.category)];
                    $(this.$refs.categorySelect).val(categoryArray).trigger('change');
                  }
                });


                this.form.description = params.description || '';
                this.form.description_desing = params.description_desing || '';
                this.form.price = parseInt(params.price || 0); 
                this.form.manage_stock = this.normalizeBoolean(params.manage_stock);
                this.form.status = params.status || 0; 
                this.modal.project_id = params.id || 0;

                this.isFinish = !!params.status;


                this.getImages();

            }
        } catch (error) {
            console.error("Error al parsear los datos del registro:", error);
        }

        this.getData();
    }

    
    this.getSizes();

    this.getColors();

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {

    $(this.$refs.userSelect).select2('destroy');

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    // Destruir select2 de categoría antes de desmontar
    if (this.$refs.categorySelect && $(this.$refs.categorySelect).hasClass('select2-hidden-accessible')) {
      $(this.$refs.categorySelect).select2('destroy');
    }
    
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none; /* Impide la interacción */
  cursor: not-allowed; /* Cambia el cursor para indicar que está deshabilitado */
}

/* Quitar el borde inferior de las filas de la tabla */
.accordion-body .table > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}
</style>


